<template>
  <div class="height-100">
    <v-breadcrumbs v-if="breadcrumbs" :items="breadcrumbs" class="px-3 pt-2 pb-0">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-btn
          text
          class="pa-0"
          :to="item.to"
          min-width="30"
          color="accent"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-btn>
      </template>
    </v-breadcrumbs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: null,
    }
  },
  created() {
    if (this.$route.name === 'credit-pay') {
      return
    }

    const breadcrumbs = [
      {
        text: '외상결제 홈',
        disabled: false,
        to: { name: 'credit-pay' },
      },
    ]

    if (this.$route.meta.topPages) {
      for (const page of this.$route.meta.topPages) {
        breadcrumbs.push({
          text: page.title,
          to: { name: page.name },
          disabled: false,
        })
      }
    }

    breadcrumbs.push({
      text: this.$route.meta.title,
      disabled: true,
    })

    this.breadcrumbs = breadcrumbs
  },
}
</script>

<style lang="scss" scoped>
.v-btn::before {
  background-color: transparent;
}
</style>
